<template>
  <!-- 拨号键盘 -->
  <div class="tel-keyboard">
    <div class="title">拨打电话</div>
    <el-input v-model="phoneNum" maxlength="11" style="width: 100%"></el-input>
    <div class="keyboard">
      <div class="keyboard-row">
        <el-button size="mini" @click="() => dealClick(1)">1</el-button>
        <el-button size="mini" @click="() => dealClick(2)">2</el-button>
        <el-button size="mini" @click="() => dealClick(3)">3</el-button>
      </div>
      <div class="keyboard-row">
        <el-button size="mini" @click="() => dealClick(4)">4</el-button>
        <el-button size="mini" @click="() => dealClick(5)">5</el-button>
        <el-button size="mini" @click="() => dealClick(6)">6</el-button>
      </div>
      <div class="keyboard-row">
        <el-button size="mini" @click="() => dealClick(7)">7</el-button>
        <el-button size="mini" @click="() => dealClick(8)">8</el-button>
        <el-button size="mini" @click="() => dealClick(9)">9</el-button>
      </div>
      <div class="keyboard-row">
        <el-button size="mini" @click="() => dealClick('*')">*</el-button>
        <el-button size="mini" @click="() => dealClick(0)">0</el-button>
        <el-button size="mini" @click="() => dealClick('#')">#</el-button>
      </div>
    </div>
    <div class="call-icon"><i class="el-icon-phone" @click="() => doCall()"></i></div>
  </div>
</template>

<script>
export default {
  name: 'TelKeyboard',
  data() {
    return {
      phoneNum: '',
    };
  },
  methods: {
    dealClick(input) {
      if (this.phoneNum.length < 11 && input != '#' && input != '*') {
        this.phoneNum += input;
      }
    },
    doCall() {
      this.$emit('doCall', this.phoneNum);
    },
  },
};
</script>

<style lang="scss" scoped>
.tel-keyboard {
  display: flex;
  flex-direction: column;
  border: solid 1px #dcdfe6;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;

  .title {
    margin-bottom: 10px;
  }
  .keyboard {
    align-self: center;
    width: 150px;
    .keyboard-row {
      width: 100%;
      height: 30px;
      margin: 5px 0;
      display: flex;
      justify-content: space-between;
    }
  }
  .call-icon {
    width: 100%;
    font-size: 50px;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
